/**
 * `getDisplayMedia` でシステム音声付きのストリームを選択し、その後
 * 不要な video トラックは即時停止して audio だけを残す。
 *
 * 既存の currentStream は新しいストリーム取得後に停止する（古いタブが
 * 露出したまま残るのを防ぐ）。
 */
export async function selectTabAudioStream(
  currentStream: MediaStream | null,
): Promise<{ stream: MediaStream; label: string | null }> {
  const nextStream = await navigator.mediaDevices.getDisplayMedia({
    audio: {
      echoCancellation: false,
      noiseSuppression: false,
      autoGainControl: false,
    },
    video: true,
  } as MediaStreamConstraints);

  const audioTracks = nextStream.getAudioTracks();
  if (!audioTracks.some((track) => track.readyState === 'live')) {
    nextStream.getTracks().forEach((track) => track.stop());
    throw new Error('システム音声を含む入力先を選択してください');
  }

  currentStream?.getTracks().forEach((track) => track.stop());
  const label =
    nextStream.getVideoTracks()[0]?.label ||
    nextStream.getAudioTracks()[0]?.label ||
    null;
  nextStream.getVideoTracks().forEach((track) => track.stop());

  return {
    stream: nextStream,
    label: label && label.trim() ? label : null,
  };
}
